// extracted by mini-css-extract-plugin
export var avatar = "card-layout-module--avatar--de29a";
export var cardContainer = "card-layout-module--cardContainer--3a501";
export var cardContent = "card-layout-module--cardContent--93855";
export var imagesRow = "card-layout-module--imagesRow--21206";
export var textCopy = "card-layout-module--textCopy--00eca";
export var textSection = "card-layout-module--textSection--fe276";